import React from 'react';
import { Flex, Image, Text, WithLink } from 'UI';
import { CardStyle1, CardStyle2, CardStyle3, CardStyle4, CardStyle5, SFlex } from './EcosystemLinkCard.styled';
import { EcosystemLink } from './EcosystemLinkCard.types';

interface EcosystemLinkCardProps {
  link: EcosystemLink;
}

const Button = ({ buttonText }: { buttonText?: string }) => (
  <Flex direction={'column'} justify={'center'} size={0} minHeight={44} className={'ecosystem-card-button'}>
    <Text type="sm" color="grey55">
      {buttonText}
    </Text>
  </Flex>
);

const Info = ({ titleType, title, description }: { titleType: string; title: string; description: string }) => (
  <>
    <Text type={titleType} className={'ecosystem-card-title'}>
      {title}
    </Text>
    <Text type="base" color="grey55" whiteSpace="pre-line">
      {description}
    </Text>
  </>
);

export const EcosystemLinkAntCard: React.FC<EcosystemLinkCardProps> = ({ link }) => {
  return (
    <div>
      <WithLink to={link.linkUrl || ''} external newTab>
        {link.designStyle === 'S1' && (
          <CardStyle1 hoverable cover={<Image src={link.imageUrl} alt={link.title} />}>
            <Flex direction={'column'}>
              <Info titleType={'text_dim_bold'} title={link.title} description={link.description} />
            </Flex>
          </CardStyle1>
        )}
        {link.designStyle === 'S2' && (
          <CardStyle2 hoverable cover={<Image src={link.imageUrl} alt={link.title} />}>
            <Flex direction={'column'}>
              <Info titleType={'h4_brand'} title={link.title} description={link.description} />
            </Flex>
          </CardStyle2>
        )}
        {link.designStyle === 'S3' && (
          <CardStyle3
            hoverable
            title={
              <Text type="heading4" color="brand" className={'ecosystem-card-title'}>
                {link.title}
              </Text>
            }
            cover={<Image src={link.imageUrl} alt={link.title} />}
          >
            <Flex direction={'column'}>
              <Text type="base">{link.description}</Text>
            </Flex>
          </CardStyle3>
        )}
        {['S4', 'S6'].includes(link.designStyle) && (
          <CardStyle4 hoverable cover={<Image src={link.imageUrl} alt={link.title} />}>
            <SFlex direction={'column'} gap={10} justify={'space-between'} alignSelf={'stretch'}>
              <Flex direction={'column'} gap={10}>
                <Info titleType={'h4_brand'} title={link.title} description={link.description} />
              </Flex>
              {link.designStyle === 'S6' && <Button buttonText={link.buttonText} />}
            </SFlex>
          </CardStyle4>
        )}
        {link.designStyle === 'S5' && (
          <CardStyle5 hoverable>
            <SFlex direction={'column'} gap={10} justify={'space-between'} align={'stretch'}>
              <Info titleType={'h4_brand'} title={link.title} description={link.description} />
              <Button buttonText={link.buttonText} />
            </SFlex>
          </CardStyle5>
        )}
      </WithLink>
    </div>
  );
};
